import { render, staticRenderFns } from "./u-user-items-icon.vue?vue&type=template&id=1b5f7941&scoped=true"
import script from "./u-user-items-icon.vue?vue&type=script&lang=js"
export * from "./u-user-items-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5f7941",
  null
  
)

export default component.exports